export const MATZEVA_ON_DELETE_REQUESTED = 'MATZEVA_ON_DELETE_REQUESTED';
export const MATZEVA_ON_DELETE_SUCCEEDED = 'MATZEVA_ON_DELETE_SUCCEEDED';
export const MATZEVA_ON_DELETE_FAILED = 'MATZEVA_ON_DELETE_FAILED';

export const MATZEVA_ON_GET_ALL_REQUESTED = 'MATZEVA_ON_GET_ALL_REQUESTED';
export const MATZEVA_ON_GET_ALL_SUCCEEDED = 'MATZEVA_ON_GET_ALL_SUCCEEDED';
export const MATZEVA_ON_GET_ALL_FAILED = 'MATZEVA_ON_GET_ALL_FAILED';

export const MATZEVA_ON_GET_FORM_REQUESTED = 'MATZEVA_ON_GET_FORM_REQUESTED';
export const MATZEVA_ON_GET_FORM_SUCCEEDED = 'MATZEVA_ON_GET_FORM_SUCCEEDED';
export const MATZEVA_ON_GET_FORM_FAILED = 'MATZEVA_ON_GET_FORM_FAILED';

export const MATZEVA_ON_GET_ONE_REQUESTED = 'MATZEVA_ON_GET_ONE_REQUESTED';
export const MATZEVA_ON_GET_ONE_SUCCEEDED = 'MATZEVA_ON_GET_ONE_SUCCEEDED';
export const MATZEVA_ON_GET_ONE_FAILED = 'MATZEVA_ON_GET_ONE_FAILED';

export const MATZEVA_ON_SAVE_REQUESTED = 'MATZEVA_ON_SAVE_REQUESTED';
export const MATZEVA_ON_SAVE_SUCCEEDED = 'MATZEVA_ON_SAVE_SUCCEEDED';
export const MATZEVA_ON_SAVE_FAILED = 'MATZEVA_ON_SAVE_FAILED';
